import testimonios from '../../data/Testimoniosdata';

import { useIdioma } from '../../context/IdiomaContext';

import './Testimonios.css';

function Testimonios() {
  const { idioma, t } = useIdioma();

  const obtenerTextoTraducido = (contenido) => {
    if (
      typeof contenido === 'object' &&
      contenido !== null
    ) {
      return (
        contenido[idioma] ||
        contenido.es ||
        ''
      );
    }

    return contenido;
  };

  return (
    <section className="pagina-testimonios">
      <header>
        <p>
          {t(
            'testimoniosPagina.etiqueta'
          )}
        </p>

        <h1>
          {t('testimoniosPagina.titulo')}
        </h1>
      </header>

      <div className="lista-testimonios">
        {testimonios.map(
          (testimonio) => (
            <article
              className="testimonio-completo"
              key={testimonio.id}
            >
              <blockquote>
                «
                {obtenerTextoTraducido(
                  testimonio.testimonial
                )}
                »
              </blockquote>

              <p>{testimonio.name}</p>

              <span>
                {obtenerTextoTraducido(
                  testimonio.position
                )}
              </span>
            </article>
          )
        )}
      </div>
    </section>
  );
}

export default Testimonios;